import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { useRouteClients } from '../hooks/use-route-clients.hook'
import { RouteClientsInterface } from '../interfaces/route-list.interface'
import { Layout } from '@/modules/shared/layouts/layout'

/**
 * Container para gerenciar clientes de rota em uma única tela
 */
export function RouteClientsContainer() {
	const { id } = useParams<{ id: string }>()
	const navigate = useNavigate()

	const {
		routes,
		filteredClients,
		selectedRouteId,
		selectedClient,
		isLoading,
		error,
		searchTerm,
		selectRoute,
		selectClient,
		handleSearch,
		selectFunctionToActions,
		loadRoutes
	} = useRouteClients()


	return (
		<Layout pageTitle="Rotas" handleGoBack={() => navigate('/')}>
			<RouteClientsInterface
				routes={routes}
				filteredClients={filteredClients}
				selectedRouteId={selectedRouteId}
				selectedClient={selectedClient}
				isLoading={isLoading}
				error={error}
				searchTerm={searchTerm}
				selectRoute={selectRoute}
				selectClient={selectClient}
				handleSearch={handleSearch}
				selectFunctionToActions={selectFunctionToActions}
				loadRoutes={loadRoutes}
			/>
		</Layout>
	)
}